import React from 'react';

import axios from 'axios';
import Alert from 'react-s-alert';
import {backendEndpoint} from '../../store/utility';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import classes from './Feedback.css'

class Feedback extends React.Component{

    constructor(props){
        super(props)
        this.email = React.createRef();
        this.content = React.createRef();
    }

    clearFeedback = () => {
        this.email.current.value = '';
        this.content.current.value = '';
    }

    submitFeedback = () => {
            let url = backendEndpoint + 'feedback/';
            let feedbackData = {
                email: this.email.current.value,
                content: this.content.current.value
            }
            axios.post(url, feedbackData)
                .then(response => {
                    Alert.info('feedback submitted, thank you for your help!');
                    this.clearFeedback();
                })
                .catch(err => {
                    Alert.error('failed to submit feedback');
                });
    }

    render(){

        return (
            <div className={classes.Feedback}>
                <Container>
                <h1>Please leave us your feedback</h1>
                <Form>
                    <Form.Group controlId="exampleForm.ControlInput1">
                        <Form.Label>Email address (optional)</Form.Label>
                        <Form.Control ref={this.email} type="email" placeholder="Please enter your email here" />
                    </Form.Group>
                    <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Please leave you feedback here.</Form.Label>
                        <Form.Control ref={this.content} as="textarea" rows="5" placeholder="Please leave you feedback here"/>
                    </Form.Group>
                </Form>
                <Row>
                    <Col>
                        <div className={classes.SubmitButton}>
                        <Button variant='info' onClick={this.submitFeedback}>Submit</Button>
                        </div>
                    </Col>
                </Row>
                </Container>
            </div>
        )
    }
}

export default Feedback;


// WEBPACK FOOTER //
// ./src/components/Feedback/Feedback.js